import { RevToggleButtonType } from "@revmatics/catalyst";

export const discoverCommunitiesToggleBtnData: RevToggleButtonType = [
  { id: "traditional_view", title: "Traditional View" },
  { id: "constellation_view", title: "Constellation View" },
];
